module.exports = __webpack_public_path__ + "media/images/default/pay_services/3_md-89f6cb153dfcdc5aba1b64a43d15e87b.jpg";